import {Routes, Route, Navigate, useParams} from "react-router-dom"
import { AccountPage, AuthPage, DiaryPage, DiarySectionPage, ExitSessionPage, MainPage, NotificationsPage, StudentAnalyticsPage } from "./routes";

function LegacyProfileRedirect() {
    const { clid } = useParams();
    return <Navigate to={`/profile/${clid}`} replace />;
}

export default function App() {
    return (
        <Routes>
            <Route path='/' element={<MainPage/>}/>
            <Route path='/auth' element={<AuthPage/>}/>
            <Route path='/exit_session' element={<ExitSessionPage/>}/>
            <Route path='/diary' element={<DiaryPage/>}/>
            <Route path='/notifications' element={<NotificationsPage/>}/>
            <Route path='/student-analytics' element={<StudentAnalyticsPage/>}/>
            <Route path='/profile/:clid' element={<AccountPage/>}/>
            <Route path='/diary/:section' element={<DiarySectionPage/>}/>

            {/* Backward-compatible redirects for legacy URLs */}
            <Route path='/sa' element={<Navigate to='/student-analytics' replace/>}/>
            <Route path='/acc/:clid' element={<LegacyProfileRedirect/>}/>
            <Route path='/diary/0' element={<Navigate to='/diary/calendar' replace/>}/>
            <Route path='/diary/p' element={<Navigate to='/diary/students' replace/>}/>
            <Route path='/diary/h' element={<Navigate to='/diary/history' replace/>}/>
            <Route path='/diary/a' element={<Navigate to='/diary/analytics' replace/>}/>
            <Route path='*' element={<Navigate to='/' replace/>}/>
        </Routes>
    );
}